import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, Text } from 'react-native';
import RenderHTML, { defaultSystemFonts } from 'react-native-render-html';

import { IndicatorScrollView } from '../common/ScrollIndicator';
import { GoldDivider, redesignPanelColors } from './redesignPanelChrome';
import SvaraModal from './SvaraModal';

const SYSTEM_FONTS = [...defaultSystemFonts, 'Sofia Sans'];

interface TournamentRulesModalProps {
	visible: boolean;
	onClose: () => void;
	isDesktop: boolean;
	width: number;
}

const TournamentRulesModal: React.FC<TournamentRulesModalProps> = ({
	visible,
	onClose,
	isDesktop,
	width,
}) => {
	const { t } = useTranslation();
	const tournamentRulesHtml = t('T_SITE_GAME_TOURNAMENT_RULES_CONTENT');

	return (
		<SvaraModal visible={visible} onClose={onClose}>
			<IndicatorScrollView
				style={styles.scroll}
				contentContainerStyle={[
					styles.scrollContent,
					{
						paddingHorizontal: isDesktop ? 80 : 20,
						maxWidth: isDesktop ? 1000 : width * 0.8,
					},
				]}
				showsVerticalScrollIndicator
				nestedScrollEnabled
			>
				<Text style={styles.rulesTitle}>{t('T_SITE_GAME_TOURNAMENT_RULES_TITLE')}</Text>

				<GoldDivider style={styles.divider} />

				<RenderHTML
					contentWidth={isDesktop ? 800 : width * 0.75}
					source={{ html: tournamentRulesHtml }}
					// The HTML renderer only uses font families it is told about.
					systemFonts={SYSTEM_FONTS}
					tagsStyles={{
						h1: {
							fontFamily: 'Sofia Sans',
							fontSize: 28,
							color: redesignPanelColors.title,
							fontWeight: 'bold',
							marginBottom: 16,
							textAlign: 'center',
						},
						h2: {
							fontFamily: 'Sofia Sans',
							fontSize: 22,
							color: redesignPanelColors.gold,
							fontWeight: 'bold',
							marginBottom: 12,
							textAlign: 'center',
						},
						p: {
							fontFamily: 'Sofia Sans',
							fontSize: 16,
							color: redesignPanelColors.white,
							textAlign: 'left',
							marginBottom: 8,
						},
						li: {
							fontFamily: 'Sofia Sans',
							fontSize: 16,
							color: redesignPanelColors.white,
							marginBottom: 4,
						},
					}}
				/>
			</IndicatorScrollView>
		</SvaraModal>
	);
};

const styles = StyleSheet.create({
	scroll: { maxHeight: 500 },
	scrollContent: {
		paddingTop: 0,
		paddingBottom: 40,
	},
	rulesTitle: {
		fontFamily: 'Sofia Sans',
		fontSize: 24,
		fontWeight: '800',
		color: redesignPanelColors.title,
		textAlign: 'center',
		marginBottom: 12,
		textShadowColor: 'rgba(255, 114, 0, 0.6)',
		textShadowOffset: { width: 0, height: 0 },
		textShadowRadius: 6,
	},
	divider: {
		marginBottom: 16,
	},
});

export default TournamentRulesModal;
